module.exports = __webpack_public_path__ + "static/logo-5be4908932d2ad3ad9d0f67663e5a591.svg";